import { siteConfig } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20background%20with%20soft%20crimson%20and%20amber%20tones%20blending%20organically%2C%20subtle%20geometric%20patterns%2C%20elegant%20editorial%20backdrop%2C%20minimal%20modern%20design%2C%20no%20text%20or%20people%2C%20smooth%20color%20transition&width=1800&height=900&seq=hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs md:text-sm font-medium tracking-widest uppercase text-accent-400 bg-accent-500/20 px-3 py-1 rounded-full mb-4">
              今日热榜
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
              {siteConfig.name}
              <span className="block text-lg md:text-2xl lg:text-3xl font-bold text-white/80 mt-2">
                {siteConfig.tagline}
              </span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-accent-300 italic mb-6">
              {siteConfig.slogan}
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteConfig.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {siteConfig.stats.map((stat) => (
                <div key={stat.label} className="text-center px-4 py-2">
                  <div className="text-lg md:text-xl font-bold text-white">{stat.value}</div>
                  <div className="text-xs text-white/50 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto text-center bg-primary-500 text-white font-bold px-8 py-3.5 rounded-md text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto text-center border-2 border-white/30 text-white font-medium px-8 py-3.5 rounded-md text-base hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line mr-2"></i>投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px]">
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=dynamic%20editorial%20collage%20of%20Chinese%20entertainment%20news%20headlines%20and%20celebrity%20silhouettes%2C%20warm%20crimson%20and%20amber%20color%20palette%2C%20modern%20magazine%20cover%20style%2C%20dramatic%20lighting%2C%20artistic%20pop%20art%20aesthetic%2C%20bold%20graphic%20design%2C%20vibrant%20energy&width=800&height=1000&seq=hero-visual&orientation=portrait"
                  alt="每日吃瓜 - 娱乐圈最新内幕热榜"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}